/* eslint-disable no-console */

import { register } from 'register-service-worker'
import { StorageKeys } from '@/helpers/storage.keys'

export function registerServiceWorker(): void {
  if (process.env.NODE_ENV === 'production') {
    register(`${process.env.BASE_URL}service-worker.js`, {
      ready() {
        console.log(
          'App is being served from cache by a service worker.\n' +
            'For more details, visit https://goo.gl/AFskqB',
        )
      },
      registered() {
        console.log('Service worker has been registered.')
      },
      cached() {
        console.log('Content has been cached for offline use.')
      },
      updatefound() {
        console.log('New content is downloading.')
      },
      updated() {
        // We store a needs update state that will be checked on the users next navigation.
        // If this is available when the user is navigating to a new route, we automatically
        // trigger a refresh to pull the updates. See frontend/src/app/router.ts
        localStorage.setItem(StorageKeys.needsUpdate, 'true')
      },
      offline() {
        console.log(
          'No internet connection found. App is running in offline mode.',
        )
      },
      error(error) {
        console.error('Error during service worker registration:', error)
      },
    })
  }
}
